import classNames from "classnames"
import s from './index.module.css';
import { useIsMinimizedMenu } from "@/hooks/useIsMinimizedMenu";
import { LoadingOutlined } from '@ant-design/icons'
import { useSelector } from "react-redux";

const Preloader = () => {
    const isMinimizedMenu = useIsMinimizedMenu();
    const preloader = useSelector((state) => state.preloader);

    if(!preloader?.active) return <></>;

    return (
        <div className={
                classNames(
                    s.preloader, 
                    {[s.preloaderForMinimizedMenu]: isMinimizedMenu},
                    {[s.preloaderFullScreen]: !preloader.showMenu},
                )
            }>
            <LoadingOutlined />
            {
                !!preloader?.text && <div className={s.savedText}>{preloader?.text}</div> 
            }
        </div> 
    )
}
export default Preloader;